(ns common.announcement.view
  (:require ["@mui/material/Button$default" :as Button]
            [common.announcement.queries :as q]
            [common.localstorage :as ls]
            [common.modal.view :refer [defmodal modal-v2]]
            [common.queries :refer [use-query]]
            [common.widgets.markdown :refer [markdown]]
            [re-frame.core :as rf]
            [uix.core :as uix :refer [$ defhook defui]]
            [uix.re-frame :refer [use-subscribe]]))

(def dismissed-key :dismissed-announcement-ids)

(defn get-dismissed-ids []
  (or (into #{} (ls/get dismissed-key)) #{}))

(defn dismiss-announcement! [id]
  (let [current (get-dismissed-ids)]
    (ls/save! dismissed-key (conj current id))))

(defn- announcement-matches-route?
  "Check if announcement should be shown on the current route.
   Returns true if:
   - routes is nil or empty (global announcement), OR
   - routes contains the current route"
  [announcement current-route]
  (let [routes (:routes announcement)]
    (or (nil? routes)
        (empty? routes)
        (contains? routes current-route))))

(defn should-show-announcement?
  "Check if announcement should be shown based on dismissal and route matching."
  [announcement current-route]
  (when announcement
    (and (not (contains? (get-dismissed-ids) (:id announcement)))
         (announcement-matches-route? announcement current-route))))

(defmodal announcement-modal :announcement/notification
  {:max-width "md"}
  [{:keys [announcement]}]
  (let [{:keys [title content]} announcement]
    ($ modal-v2
       {:title title
        :footer ($ Button
                   {:variant "contained"
                    :onClick (fn []
                               (rf/dispatch [:modal/close]))}
                   "Got it")}
       ($ markdown {:children content}))))

(defhook use-announcements []
  ;; Get current route for announcement filtering
  (let [current-route (use-subscribe [:router/current-route])
        route-name (some-> current-route :data :name)

        {:keys [data]} (use-query q/latest-announcement-query)]
    (uix/use-effect
     (fn []
       (when (some-> data (should-show-announcement? route-name))
         (rf/dispatch [:modal/open {:id :announcement/notification
                                    :on-close-callback #(dismiss-announcement! (:id data))
                                    :props {:announcement data}}])))
     [data route-name])))

(defui announcement-runtime []
  (use-announcements))
